export const ckBTC_ID = "mxzaz-hqaaa-aaaar-qaada-cai";

export const ckBTC_MINTER_ID = "mqygn-kiaaa-aaaar-qaadq-cai";
